export default {
  additionalRivalsTerms: "Additional Rivals Terms of Service",
  afterLinksText:
    " and I agree to be charged the non-refundable rate above, subject to change, plus any applicable taxes, on an auto-renewal basis until I cancel. ",
  doNotSell: "Do Not Sell My Personal Information",
  followingTerms: " and to the following terms: ",
  iAgree: "By clicking the button below, I agree to the ",
  paidTerms1:
    "You agree that we may charge your payment method for the non-refundable price stated above, plus any taxes and fees, on an automatic renewal basis until you revoke this consent or cancel your subscription(s). Subscription fees are charged at the beginning of each subscription period. If your offer includes a free trial, the free trial begins immediately. To avoid the subscription fee, please visit ",
  paidTerms2: "to cancel before the free trial period ends. Visit",
  paidTerms3:
    "to see details of your bill including any charges, applicable taxes and fees.",
  paidTerms4:
    "You will receive all billing and account notices online or by email. To view or manage your Privacy information visit ",
  rivalsTerms: "Additional Rivals.com Terms of Service",
  strongText:
    "I also acknowledge that to avoid being charged at the rate above, I must cancel my subscription before any applicable free trial period ends.",
  subPage: "your subscriptions page",
  yahooPolicy: "Yahoo Privacy Policy",
  yahooTerms: "Yahoo Terms of Service"
};
